import { useGroups } from "@/api/groups";
import { GroupsPane } from "@/components/AdminPanel/Organization/components/groups/GroupsPane";
import React from "react";

const GroupsPage: React.FC = () => {
  const { data: groups, isLoading, isError } = useGroups();

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <div className="p-4 text-lc-blocked dark:text-lc-blocked">
        Error loading groups.
      </div>
    );
  }

  return (
    <>
      <title>Groups</title>
      <GroupsPane groups={groups ?? []} />
    </>
  );
};

export default GroupsPage;
